export type FormStatus = `VALID` | `INVALID` | `PENDING ` | `DISABLED`;
export enum RegExpValidations {
  // tslint:disable-next-line:quotemark
  NameValidation = "^([a-zA-Z]{1,}'?-?[a-zA-Z]{2,}s?([a-zA-Z]{1,})?)$",
  EmailValidation = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}',
  DomainValidation = '^[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9-]+)*([-.]{1})[a-zA-Z]{2,10}$',
  DomainValidationHttps = '^(http(s|)://)[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9-]+)*([-.]{1})[a-zA-Z]{2,10}$',
  DomainValidationCrmUrl = '^(http(s|)://)[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9-]+)*([-.]{1})[a-zA-Z]{2,10}(/|/[a-z]+|)(:[0-9]+(/|/[a-zA-Z]+(/|)|)|)$',
  TwilioSenderId = '^[ A-Za-z0-9_&+-]+$', // all (letters, numbers, spaces, +, -, &, _)
  AtLeastOneLetter = '.*[A-Za-z].*', // must have a letter
}
